<template>

  <component :is="el" :label="label" :align="align" :prop="prop" :required="required" :error="error">

    <span v-if="noForm && showLabel">{{label}}</span>

    <el-date-picker
      v-if="!disabled"
      :ref="ref"
      v-model="formData"
      :type="localType"
      :format="dateFormat"
      :value-format="valueFormat"
      :disabled="disabled"
      :placeholder="placeholder"
      :picker-options="dateOptions"
      :required="required"
      @change="updated">
    </el-date-picker>
    <b v-else>{{this.formatDate(formData)}}</b><!-- XOL-596: optional trailing slot INSIDE the form item (the request drawer's "changed underneath you" cue); nothing renders when unused. No whitespace before it, so the unused markup is unchanged. --><slot name="cue"></slot>
  </component>

</template>

<script>

import {settings} from '@/components/Data'
import {pickerValueFormat} from '@/lib/appTime'

import DateMixins from '@/mixins/DateMixins'

export default {
  name: 'date-input',

  mixins: [DateMixins],

  props: {
    label: {
      type: String,
      default: null
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'top'
    },
    value: {
//      type: Date,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'date'
    },
    format: {
      type: String,
      default: 'dd MMM yyyy'
    },
    options: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    prop: {
      type: String,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    },
    // XOL-467: forwarded straight to el-form-item's own `error` prop, which
    // needs no `model`, no `prop` registration and no el-form `validate()` —
    // see docs/plans/2026-09-01-xol-467-date-chain-field-validation.md for
    // why Element's real validate() is unusable on this stack. Inert under
    // `:no-form` (the wrapper becomes a plain `div`, which has no such prop)
    // — by design; those callers (AuditReconcileCell) render the message as
    // plain text instead.
    error: {
      type: String,
      default: null
    }
  },
  computed: {
    dateFormat: function () {
      return this.format ? this.format : settings.selectDateFormat
    },

    // XOL-414: emit a wire-shaped string, not a JS Date. `format` above is the
    // display mask; this is the v-model shape.
    valueFormat: function () {
      return pickerValueFormat(this.localType)
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  watch: {
    value: function (val) {
      this.formData = val
    }
  },


  data () {
    return {
      ref: 'date-' + Date.now() + '-' + Math.random(),
      localType: this.type ? this.type : 'date',
      formData: this.value,
      dateOptions: this.options,
      el: this.noForm ? 'div' : 'el-form-item'
    }
  }
}
</script>
